import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";
import { connectFunctionsEmulator } from "firebase/functions";
import { projectAuth, projectFirestore, functions } from "./config";

/**
 * Local emulator wiring for the Dashboard.
 *
 * This is a NO-OP unless `VUE_APP_USE_EMULATORS === "true"`, so production
 * builds are entirely unaffected. When enabled, it points Auth, Firestore, and
 * Functions at the local Firebase Emulator Suite instead of production
 * `tint-bolt-1aba6`, letting you exercise the app as a logged-in user with
 * synthetic data and never touching real accounts.
 *
 * Ports must match Cloud Functions v2/firebase.emulator.json:
 *   Auth      127.0.0.1:9099
 *   Firestore 127.0.0.1:8899   (8080 avoided; unusable on some Windows hosts)
 *   Functions 127.0.0.1:5001
 *
 * Imported for its side effect as the very first import in main.js, so the
 * connections are established before any auth/firestore listener is attached.
 */

const HOST = process.env.VUE_APP_EMULATOR_HOST || "127.0.0.1";
const AUTH_PORT = Number(process.env.VUE_APP_EMULATOR_AUTH_PORT || 9099);
const FIRESTORE_PORT = Number(process.env.VUE_APP_EMULATOR_FIRESTORE_PORT || 8899);
const FUNCTIONS_PORT = Number(process.env.VUE_APP_EMULATOR_FUNCTIONS_PORT || 5001);

let connected = false;

export function connectEmulatorsIfEnabled() {
  if (connected) return false;
  if (process.env.VUE_APP_USE_EMULATORS !== "true") return false;

  connectAuthEmulator(projectAuth, `http://${HOST}:${AUTH_PORT}`, { disableWarnings: true });
  connectFirestoreEmulator(projectFirestore, HOST, FIRESTORE_PORT);
  connectFunctionsEmulator(functions, HOST, FUNCTIONS_PORT);

  connected = true;
  // eslint-disable-next-line no-console
  console.info(
    `[emulators] Dashboard connected to local Firebase Emulator Suite on ${HOST} ` +
      `(auth:${AUTH_PORT}, firestore:${FIRESTORE_PORT}, functions:${FUNCTIONS_PORT}). ` +
      "Production is NOT in use.",
  );
  return true;
}

// Side effect: connect immediately on import (guarded by the env flag above).
connectEmulatorsIfEnabled();
